import React from "react";

const faq10 = () =>{
  return(
    <>
      <p>
        TB per erbjudande (rad) x Årsvolym
      </p>
      <p>
        Se Flik: <u>Fält & Rubriker/Årstäckningsbidrag   </u>
      </p>
      
    </>
  );
}
export default faq10;